import React from 'react';
import FormGenerator from './FormGenerator';
import { useFormGeneratorHandleChangeV2 } from '../hooks/useFormGeneratorHandleChangeV2';
import { formDefUserLogin } from '../utils/form-definition-lib';
import Btn from './Btn';

const FormLogin = (props) => {
  let initialState = {
    username: '',
    password: ''
  };
  const { state, handleChange, setState, errors, setErrors } = useFormGeneratorHandleChangeV2(initialState, {}, null);

  const validator = (formState) => {
    let valid = true; // test je inicijalno polozen
    let _errors = {};
    // ovde se kasnie jdodaju validatori koji mogu da obore test
    setErrors({
      ..._errors
    });
    return valid;
  }

  const cbSetErrors = (_errors) => {
    setErrors({
      ..._errors
    });
  };


  const _click = () => {
    // click na SUBMIT taster
    // console.log('clicked on login', state);
    props.submit(state);
  }

  let jsxTitle = (
    <h3>Login</h3>
  );
  let jsxBtn = (
    <Btn
      title="Uloguj se"
      i="fa fa-unlock"
      handleClick={_click}
    />
  );

  return (
    <>
      {jsxTitle}
      <FormGenerator
        formDefinition={formDefUserLogin}
        formState={state}
        formErrors={errors}
        handleChange={handleChange}
      />
      <div className="unicompo-dialog__btns">
        {jsxBtn}
      </div>
    </>
  );
};

export default FormLogin;